<template>
  <div class="plv-iar-topic__content">
    <div class="plv-iar-topic__content-title">
      {{ topicData.name }}
    </div>
    <div class="plv-iar-topic__content-detail">
      <div class="plv-iar-topic__content-detail-data">
        <div class="plv-iar-topic__content-icon--people">
          <img src="./imgs/people.png"/>
        </div>
        <div class="plv-iar-topic__content-people-count"> {{ topicData.leftNumber + topicData.rightNumber }} {{ iarTrans('topic.joinCounts') }}</div>
        <div class="plv-iar-topic__content-status" :class="{'plv-iar-topic__content-status--end': topicData.status === 'over'}">
          <span>
            {{ topicData.status === 'running' ? iarTrans('topic.going') : iarTrans('topic.end') }}
          </span>
        </div>
      </div>

      <!--  PK结果-->
      <div v-if="showResult">
        <div class="plv-iar-topic-process plv-font-din-pro-regular">
          <div
            v-if="processData.leftProcess > 0"
            class="plv-iar-topic-process--red"
            :class="{
              'plv-iar-topic-process--full': processData.leftProcess === 100
            }"
            :style="{'max-width': processData.leftProcess + '%' }">
            <span> &nbsp; {{ processData.leftValue }} </span>
          </div>
          <div v-if="processData.leftProcess && processData.rightProcess" class="plv-iar-topic-process--center"></div>
          <div
            v-if="processData.rightProcess > 0"
            class="plv-iar-topic-process--blue"
            :class="{
              'plv-iar-topic-process--full': processData.rightProcess === 100
            }"
            :style="{'max-width': processData.rightProcess + '%' }">
            <span>{{ processData.rightValue }} &nbsp;</span>
          </div>
        </div>
        <div class="plv-iar-topic-process-footer">
          <div class="plv-iar-topic-process-footer-item plv-iar-topic-process-footer-left">
            <IconTipRight class="plv-iar-topic-icon-right"
                          v-show="topicData.answer === 'left'"
                          :size="16"
                          color="#ef3a4f" />
            <span>{{ topicData.left }}</span>
          </div>
          <div class="plv-iar-topic-process-footer-item plv-iar-topic-process-footer-right">
            <IconTipRight class="plv-iar-topic-icon-right"
                          v-show="topicData.answer === 'right'"
                          :size="16"
                          color="#2260cf" />
            <span>{{ topicData.right }}</span>
          </div>
        </div>
      </div>

      <!--  选择正反方 -->
      <div v-else class="plv-iar-topic__content-detail-PK">
        <div class="plv-iar-topic-PK-btn plv-iar-topic-PK-btn--red" @click="choose('left')">
          <span>{{ topicData.left }}</span>
        </div>
        <div class="plv-iar-topic-PK-bg--hidden"></div>
        <div class="plv-iar-topic-PK-bg"></div>
        <div class="plv-iar-topic-PK-btn plv-iar-topic-PK-btn--blue" @click="choose('right')">
          <span>{{ topicData.right }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import basicMixin from '../../assets/mixins/basic';
import IconTipRight from '../../icon-components/icons/icon-tip-right';
import Decimal from 'decimal.js';

// 返回20 - 80 的数值范围
const rangeValue = function(val) {
  return val > 90 ? 90 : val < 10 ? 10 : val;
};
export default {
  name: 'TopicContent',
  mixins: [basicMixin],
  components: {
    IconTipRight
  },
  props: {
    topicData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
    };
  },
  computed: {
    selectRight() {
      return true;
    },
    // 是否展示结果
    showResult() {
      const { topicData } = this;
      if (topicData.status === 'over') {
        return true;
      } else if (topicData.status === 'running' && topicData.userIsAnswered) {
        return true;
      } else {
        return false;
      }
    },
    processData() {
      const { topicData } = this;
      const left = topicData.leftNumber;
      const right = topicData.rightNumber;

      // 两边都是 0 的情况
      if (left === 0 && right === 0) {
        return {
          leftProcess: 50,
          rightProcess: 50,
          leftValue: this.iarTrans('topic.nobody'),
          rightValue: this.iarTrans('topic.nobody')
        };
      }

      // 有一方是0 ，跳过计算
      if (left === 0 || right === 0) {
        return {
          leftProcess: left > 0 ? 100 : 0,
          rightProcess: right > 0 ? 100 : 0,
          leftValue: left > 0 ? '100%' : 0,
          rightValue: right > 0 ? '100%' : 0
        };
      }
      // 处理JS 精准度问题
      const leftValue = Math.round(new Decimal(new Decimal(left).div(new Decimal(left).add(new Decimal(right)))).mul(100));
      const rightValue = new Decimal(100).sub(new Decimal(leftValue));

      return {
        leftProcess: rangeValue(leftValue),
        rightProcess: rangeValue(rightValue),
        leftValue: leftValue + '%',
        rightValue: rightValue + '%',
      };
    },
  },
  methods: {
    choose(type) {
      this.$emit('choose-answer', type);
    },
  }
};
</script>
<style lang="scss">
@import '../../assets/styles/basic.scss';

$blue: #2260CF;
$red: #ef3a4f;

@mixin process {
  flex: 1;
  height: 100%;
  text-align: center;
}

@mixin redProcess {
  @include process();
  border-radius: 30px 0 0 30px;
  background-color: $red;
  box-shadow: 2px 4px 10px 0 rgba(238, 58, 79, 0.2);
}

@mixin blueProcess {
  @include process();
  border-radius: 0 30px 30px 0;
  background-color: $blue;
  box-shadow: -2px 4px 10px 0 rgba(34, 96, 207, 0.2);
}

.plv-iar-topic__content {
  width: 100%;
  height: 100%;
}

.plv-iar-topic__content-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333333;
}

.plv-iar-topic__content-detail-data {
  display: flex;
  align-items: center;
}

.plv-iar-topic__content-icon--people {
  margin-right: 4px;
  opacity: .4;
}

.plv-iar-topic__content-people-count {
  opacity: 0.6;
  color: #333333;
  font-size: 12px;
  margin-right: 8px;
}

.plv-iar-topic__content-status {
  border-radius: 24px;
  color: #ff3d00;
  background-color: #fee7e9;
  font-size: 12px;
  padding: 1px 4px;

  span {
    display: block;
    transform: scale(.83);
  }
}
.plv-iar-topic__content-status--end {
  background-color: #e9e5e5;
  color: #333333;
}

.plv-iar-topic__content-detail-PK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
}

.plv-iar-topic-PK-btn {
  flex: 1;
  height: 100%;
  line-height: 50px;
  text-align: center;
  position: relative;
  cursor: pointer;

  span {
    max-width: 90%;
    position: absolute;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    display: block;
    z-index: 10;
  }
}

.plv-iar-topic-PK-btn--red {
  @include redProcess();
  padding-left: 20px;
  span {
    left: 0;
    margin-left: 15px;
  }
}

.plv-iar-topic-PK-btn--blue {
  @include blueProcess();
  padding-right: 20px;
  span {
    right: 0;
    margin-right: 15px;
  }
}

.plv-iar-topic-PK-btn--red:after {
  position: absolute;
  right: -16px;
  height: 100%;
  content: ' ';
  background-image: url(./imgs/red-radius.png);
  background-size: 100% 100%;
  width: 20px;
}

.plv-iar-topic-PK-btn--blue:after {
  position: absolute;
  left: -16px;
  height: 100%;
  content: ' ';
  background-image: url(./imgs/blue-radius.png);
  background-size: 100% 100%;
  width: 20px;
}

.plv-iar-topic-PK-bg--hidden {
  width: 70px;
  height: 40px;
}

.plv-iar-topic-PK-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  background: url(./imgs/pk.png) 100% 100%;
  background-size: 100% 100%;
}

.plv-iar-topic-process {
  display: flex;
  height: 44px;
  align-items: center;
  line-height: 44px;
  margin-top: 20px;
  font-size: 20px;
  font-weight: normal;
  color: white;
  position: relative;
  min-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.plv-iar-topic-process--center {
  background-image: url(./imgs/center-process.png);
  width: 26px;
  height: 100%;
  background-size: 100% 100%;
  transform: scale(1.2, 1);
}

.plv-iar-topic-process--red {
  @include redProcess();
  text-align: left;
  span {
    margin-left: 6px;
    position: absolute;
    left: 0;
  }
}

.plv-iar-topic-process--blue {
  @include blueProcess();
  text-align: right;
  span {
    margin-right: 6px;
    position: absolute;
    right: 0;
  }
}
.plv-iar-topic-process--full {
  border-radius: 30px 30px 30px 30px;
}

.plv-iar-topic-process-footer {
  margin-top: 8px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.plv-iar-topic-process-footer-item {
  font-size: 14px;
  font-weight: normal;
  display: flex;
  height: 20px;
  align-items: center;
  .plv-iar-topic-icon-right {
    margin-right: 4px;
    margin-top: 1px;
  }
}
</style>
